export const LOGIN_FROM_LA = 'LOGIN_FROM_LA';
export const REDIRECT_FROM_LA = 'REDIRECT_FROM_LA';
export const CLOSE_LA = 'CLOSE_LA';
export const SHOW_LA = 'SHOW_LA';
export const BEGIN_FETCH_LOGIN_ASSISTANT_CONTENT = 'BEGIN_FETCH_LOGIN_ASSISTANT_CONTENT';
export const RECEIVE_LOGIN_ASSISTANT_CONTENT = 'RECEIVE_LOGIN_ASSISTANT_CONTENT';
export const FETCH_LOGIN_ASSISTANT_CONTENT_ERROR = 'FETCH_LOGIN_ASSISTANT_CONTENT_ERROR';
